/* Currency-aware price display.
   The store's legacy money_format hardcodes a '$' symbol, which is wrong for
   PKR but correct for USD. So we only rewrite '$' -> 'Rs ' when the visitor's
   ACTIVE presentment currency is PKR. For USD (or any other enabled currency)
   we leave prices untouched so the correct symbol shows.
   Works on server-rendered prices and dynamically updated ones (variant
   switches, cart changes) via a MutationObserver. */
(function () {
  var active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'PKR';
  if (active !== 'PKR') return; // e.g. USD: the '$' is already correct, do nothing

  var RE = /\$(?=\s?\d)/g;
  function fixTextNode(node) {
    var v = node.nodeValue;
    if (v && v.indexOf('$') !== -1 && RE.test(v)) {
      RE.lastIndex = 0;
      var nv = v.replace(RE, 'Rs ');
      if (nv !== v) node.nodeValue = nv;
    }
    RE.lastIndex = 0;
  }
  function walk(root) {
    if (!root) return;
    try {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) { fixTextNode(n); }
    } catch (e) {}
  }
  function run() {
    if (!document.body) return;
    walk(document.body);
    try {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'characterData') {
            fixTextNode(m.target);
          } else if (m.addedNodes) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var nd = m.addedNodes[j];
              if (nd.nodeType === 3) fixTextNode(nd);
              else if (nd.nodeType === 1) walk(nd);
            }
          }
        }
      });
      obs.observe(document.body, { subtree: true, childList: true, characterData: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
